module.exports = __webpack_public_path__ + "img/icon-search-popup.6c48f6fc.svg";